// components/Common/Shimmer.js
import React from "react";
import "./Shimmer.scss";

const Shimmer = ({ height = 48, count = 1 }) => (
  <div>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="shimmer mb-3"
        style={{ height: height, borderRadius: 8 }}
      />
    ))}
  </div>
);

export default Shimmer;
